import { Button } from "~/common/mui";
import { useIsMinDesktopSize } from "~/common/hooks/useMediaQuery";
import { resolveUrl } from "~/utils/url/urlResolver";
import { useTranslation } from "react-i18next";
import {
  BannerMsgImg,
  BannerMsgText,
  BannerMsgTitle,
  BannerMsgDescription,
  BannerButton,
  BannerMsgDescPlusButton,
} from "~/pages/HeaterSelectionAssistantPage/HeaterSelectionAssistantPage.styles";

export function BannerHS() {
  const { t } = useTranslation();
  const isMinDesktop = useIsMinDesktopSize();
  const url = resolveUrl("/mount/induction-units-with-medium-frequency-technology");

  return (
    <>
      <BannerMsgImg
        src={"https://cdn.schaeffler-ecommerce.com/cdn/bannerHeaterSelectionAssistant.jpg"}
      />
      {isMinDesktop ? (
        <>
          <BannerMsgText>
            <BannerMsgTitle>{t("heaterSelectionAssistant.banner.title")}</BannerMsgTitle>
            <BannerMsgDescription>{t("heaterSelectionAssistant.banner.description")}</BannerMsgDescription>
          </BannerMsgText>
          <BannerButton href={url}>
            {t("heaterSelectionAssistant.banner.button")}
          </BannerButton>
        </>
      ) : (
        <BannerMsgText>
          <BannerMsgTitle>{t("heaterSelectionAssistant.banner.title")}</BannerMsgTitle>
          <BannerMsgDescPlusButton>
            <BannerMsgDescription>{t("heaterSelectionAssistant.banner.description")}</BannerMsgDescription>
            <BannerButton href={url}>
              {t("heaterSelectionAssistant.banner.button")}
            </BannerButton>
          </BannerMsgDescPlusButton>
        </BannerMsgText>
      )}
    </>
  );
}
